import { BalanceBadgeStatus } from '@dataTypes/billing.types'

export const BALANCE_BADGE_COLOR: Record<
  BalanceBadgeStatus,
  'red' | 'yellow' | 'vivid-green'
> = {
  [BalanceBadgeStatus.Unpaid]: 'red',
  [BalanceBadgeStatus.Partial]: 'yellow',
  [BalanceBadgeStatus.Paid]: 'vivid-green',
}

export const MENU_OPTIONS = [
  { key: 'send-an-e-claim', value: 'Send an E-Claim' },
  { key: 'send-an-advance-claim', value: 'Send an Advance Claim' },
  { key: 'send-a-manual-claim', value: 'Send a Manual Claim' },
  { key: 'send-an-e-claim-plus-pay', value: 'Send an E-Claim + Pay' },
  {
    key: 'send-an-advance-claim-plus-pay',
    value: 'Send an Advance Claim + Pay',
  },
  { key: 'send-a-manual-claim-plus-pay', value: 'Send a Manual Claim + Pay' },
  { key: 'print', value: 'Print' },
  { key: 'pay', value: 'Pay' },
  { key: 'adjust', value: 'Adjust' },
]

export const PAYMENT_TYPE_OPTION = [
  { key: 'american-express', value: 'American Express' },
  { key: 'debit', value: 'Debit' },
  { key: 'cash', value: 'Cash' },
  { key: 'direct-deposit', value: 'Direct Deposit' },
  { key: 'personal-check', value: 'Personal Check' },
  { key: 'account-credit', value: 'Account Credit' },
  { key: 'previously-existing', value: 'Previously Existing' },
]

export const CREDIT_ADJUSTMENT_TYPE = [
  { key: 'professional-courtesy', value: 'Professional Courtesy' },
  { key: 'write-off', value: 'Write Off' },
  { key: 'credit-adjustment', value: 'Credit Adjustment' },
  { key: 'error-credit', value: 'Error - Credit' },
  { key: 'discount-plan-20', value: 'Discount Plan 20%' },
]

export const DEBIT_ADJUSTMENT_TYPE = [
  { key: 'nsf-fee', value: 'NSF Fee' },
  { key: 'debit-adjustment', value: 'Debit Adjustment' },
  { key: 'error-debit', value: 'Error - Debit' },
  { key: 'finance-charge', value: 'Finance Charge' },
]

export const SUMMARY_COLUMNS = [
  {
    key: 'date',
    header: 'Date',
  },
  {
    key: 'transaction',
    header: 'Transaction',
  },
  {
    key: 'details',
    header: 'Details',
  },
  {
    key: 'clinic',
    header: 'Clinic',
  },
  {
    key: 'patient',
    header: 'Patient',
  },
  {
    key: 'amount',
    header: 'Amount',
  },
  {
    key: 'runningBalance',
    header: 'Running Balance',
  },
]

export const MENU_ITEMS = [
  {
    key: 'addPatientPayment',
    label: 'Add Patient Payment',
    link: '/billing/add-payment',
  },
  {
    key: 'addInsurancePayment',
    label: 'Add Insurance Payment',
    link: '/billing/add-insurance',
  },
  {
    key: 'addAdjustment',
    label: 'Add Adjustment',
    link: '/billing/add-adjustment',
  },
  {
    key: 'addPaymentRefund',
    label: 'Add Payment Refund',
    link: '',
  },
  { key: 'voidInvoice', label: 'Void Invoice', link: '' },
]

export const MENU_ITEMS_2 = [
  { key: 'sendToBatch', label: 'Send To Batch' },
  { key: 'sendToBatchWithAttachment', label: 'Send To Batch With Attachment' },
]
